<template lang="pug">
#list.comAll(v-dragDiv,v-show="!actionData.isMini")
  .title.moveDragDiv
    span {{actionData.cnName}}
    i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
    i.el-icon-close(title='关闭' @click='closeAdd')
  .nav
    //- addType项目用，同步误删，否则得改功能
    notationList(ref="notationList" :type="actionData.payload" @showAnnotation="showAnnotation" :addType='actionData.addType')
</template>

<script>
import notationList from "@/CommonDP/mongeView/question/notationList.vue";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import mongeCommon from "@/CommonDP/mongeView/common/mongeCommon";
export default {
  components: { notationList },
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    miniCom() {
      this.$emit('closeCom', 'list', true);
    },
    closeAdd() {
      this.$emit('closeCom', 'list', false);
    },
    // 展示云线
    showAnnotation(list, dicList) {
      mongeCommon.showAllAnnotation(list, dicList, this.actionData?.payload);
    },
    clearAnnotation() {
      mongeApiMlib.clearAnnotation();
    }

  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
#list{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 300px;
  .title{
    cursor: auto;
  }
  .nav{
    height: calc(100% - 50px);
    overflow-y: auto;
  }
}
</style>
